import {BrowserModule} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {HttpClientModule} from '@angular/common/http';
import {InputTextModule} from 'primeng/inputtext';
import {InputTextareaModule} from 'primeng/inputtextarea';
import {InputNumberModule} from 'primeng/inputnumber';
import {ButtonModule} from 'primeng/button';
import {TableModule} from 'primeng/table';
import {DialogModule} from 'primeng/dialog';
import {ConfirmDialogModule} from 'primeng/confirmdialog';
import {DropdownModule} from 'primeng/dropdown';
import {RadioButtonModule} from 'primeng/radiobutton';
import {RatingModule} from 'primeng/rating';
import {ToolbarModule} from 'primeng/toolbar';
import {ConfirmationService, MessageService} from 'primeng/api';

import {AppComponent} from './app.component';
import {RouterModule, RouterOutlet, Routes} from "@angular/router";
import {LandingPageComponent} from './staticPages/landing-page/landing-page.component';
import {MenubarModule} from "primeng/menubar";
import {AnimateModule} from "primeng/animate";
import {ScrollPanelModule} from "primeng/scrollpanel";
import {HomeComponent} from "./site/home/home.component";
import {TemplateComponent} from "./site/template/template.component";
import {SuccessStoryListPageComponent} from "./site/success-story-list-page/success-story-list-page.component";
import {SuccessStoryPageComponent} from "./site/success-story-page/success-story-page.component";
import {UpdatingPageComponent} from "./site/updating-page/updating-page.component";
import {ContactUsPageComponent} from "./site/contact-us-page/contact-us-page.component";
import {TermsOfServicePageComponent} from "./site/terms-of-service-page/terms-of-service-page.component";
import {AboutUsComponent} from "./site/about-us/about-us.component";
import {AdminLoginPageComponent} from "./admin/admin-login-page/admin-login-page.component";
import {AdminTemplateComponent} from "./admin/admin-template/admin-template.component";
import {AdminOverviewComponent} from "./admin/admin-overview/admin-overview.component";
import {AdminSuccessStoriesComponent} from "./admin/admin-success-stories/admin-success-stories.component";
import {AdminBlogsComponent} from "./admin/admin-blogs/admin-blogs.component";
import {AdminFeaturesComponent} from "./admin/admin-features/admin-features.component";
import {AdminOtherPageComponent} from "./admin/admin-other-page/admin-other-page.component";
import {AdminMainPageComponent} from "./admin/admin-main-page/admin-main-page.component";
import {AdminMenuPageComponent} from "./admin/admin-menu-page/admin-menu-page.component";
import {OtherPageComponent} from "./site/other-page/other-page.component";
import {AdminMenuManagerComponent} from "./admin/admin-menu-manager/admin-menu-manager.component";
import {OtherPageListComponent} from "./site/other-page-list/other-page-list.component";
import {AdminSettingPageComponent} from "./admin/admin-setting-page/admin-setting-page.component";
import {AdminAttributesComponent} from "./admin/admin-attributes/admin-attributes.component";
import {AdminContactPageComponent} from "./admin/admin-contact-page/admin-contact-page.component";
import {AdminNewsComponent} from "./admin/admin-news/admin-news.component";
import {AdminCustomersComponent} from "./admin/admin-customers/admin-customers.component";
import {TestComponent} from "./admin/test/test.component";
import {DateTextPipe} from "./pips/date-text.pipe";
import {NowruzMainPageComponent} from "./staticPages/nowruz/nowruz-main-page/nowruz-main-page.component";
import {LandingTemplateComponent} from "./staticPages/landing-template/landing-template.component";
import {NowruzArboricultureComponent} from "./staticPages/nowruz/nowruz-arboriculture/nowruz-arboriculture.component";
import {NowruzKheshtComponent} from "./staticPages/nowruz/nowruz-khesht/nowruz-khesht.component";
import {NowruzSoorComponent} from "./staticPages/nowruz/nowruz-soor/nowruz-soor.component";
import {NowruzSweetsComponent} from "./staticPages/nowruz/nowruz-sweets/nowruz-sweets.component";
import {WaitingComponent} from "./componnts/waiting/waiting.component";


const ROUTES: Routes = [
    {
        path: 'germanPage',
        component: LandingPageComponent,
    },
    {
        path: 'admin',
        component: AdminLoginPageComponent,
    },
    {
        path: "",
        component: TemplateComponent,
        children: [
            {
                path: '',
                component: HomeComponent,
            },
            {
                path: 'waiting',
                component: WaitingComponent,
            },
            {
                path: 'stories',
                component: SuccessStoryListPageComponent,
            },
            {
                path: 'success_story/:pageUid',
                component: SuccessStoryPageComponent,
            },
            {
                path: 'updates',
                component: UpdatingPageComponent,
            },
            {
                path: 'contact-us',
                component: ContactUsPageComponent,
            },
            {
                path: 'terms-of-service',
                component: TermsOfServicePageComponent,
            },
            {
                path: 'about-us',
                component: AboutUsComponent,
            },
            {
                path: 'pages',
                component: OtherPageListComponent,
            },
            {
                path: 'page/:pageUid',
                component: OtherPageComponent,
            },
            {
                path: 'features',
                component: OtherPageListComponent,
            },
            {
                path: 'feature/:pageUid',
                component: OtherPageComponent,
            },
            {
                path: 'blogs',
                component: OtherPageListComponent,
            },
            {
                path: 'blog/:pageUid',
                component: OtherPageComponent,
            },
            {
                path: 'all-news',
                component: OtherPageListComponent,
            },
            {
                path: 'news/:pageUid',
                component: OtherPageComponent,
            },
            {
                path: 'customers',
                component: OtherPageListComponent,
            },
            {
                path: 'customer/:pageUid',
                component: OtherPageComponent,
            },
        ]
    },
    {
        path: "gift",
        component: LandingTemplateComponent,
        children: [
            {
                path: '',
                component: NowruzMainPageComponent,
            },
            {
                path: 'tree',
                component: NowruzArboricultureComponent,
            },
            {
                path: 'khesht',
                component: NowruzKheshtComponent,
            },
            {
                path: 'soor',
                component: NowruzSoorComponent,
            },
            {
                path: 'sweets',
                component: NowruzSweetsComponent,
            },
        ]
    },
    {
        path: "admin",
        component: AdminTemplateComponent,
        children: [
            {
                path: 'main-page',
                component: AdminMainPageComponent,
            },
            {
                path: 'overview',
                component: AdminOverviewComponent,
            },
            {
                path: 'success-stories',
                component: AdminSuccessStoriesComponent,
            },
            {
                path: 'blogs',
                component: AdminBlogsComponent,
            },
            {
                path: 'features',
                component: AdminFeaturesComponent,
            },
            {
                path: 'other-page',
                component: AdminOtherPageComponent,
            },
            {
                path: 'menu',
                component: AdminMenuManagerComponent,
            },
            {
                path: 'setting',
                component: AdminSettingPageComponent,
            },
            {
                path: 'attribute',
                component: AdminAttributesComponent,
            },
            {
                path: 'contact',
                component: AdminContactPageComponent,
            },
            {
                path: 'news',
                component: AdminNewsComponent,
            },
            {
                path: 'customer',
                component: AdminCustomersComponent,
            },
            {
                path: 'test',
                component: TestComponent,
            }
        ]
    }

];

@NgModule({
    declarations: [
        AppComponent,
        LandingPageComponent
    ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        FormsModule,
        TableModule,
        HttpClientModule,
        InputTextModule,
        DialogModule,
        ToolbarModule,
        ConfirmDialogModule,
        RatingModule,
        InputNumberModule,
        InputTextareaModule,
        RadioButtonModule,
        DropdownModule,
        ButtonModule,
        RouterOutlet,
        RouterModule.forRoot(ROUTES),
        MenubarModule,
        AnimateModule,
        ScrollPanelModule

    ],
    providers: [
        ConfirmationService,
        MessageService,


    ],
    exports: [],
    bootstrap: [AppComponent]

})
export class AppModule {
}
